import * as React from "react";
import "debounce";
import "tabbable";
import { useCurrentBreakPoint } from "../helpers/helper/hooks/use-current-breakpoint.mjs";
import { Table } from "../table/table/table.mjs";
import { PacketsTableHeader } from "./packets-table-header.mjs";
import { ScrollTable } from "./scroll-table.mjs";
import { SectionHeading } from "./section-heading.mjs";
import { ServiceRow } from "./service-row.mjs";
import { ViewAllButton } from "./view-all-button.mjs";
import { ViewerSlotRow } from "./viewer-slot-row.mjs";
const ServiceGroups = (props) => {
  const { packets, serviceGroups, isFirstTable, viewerSlots, initialHeadingLevel } = props;
  const currentBreak = useCurrentBreakPoint();
  const isMobile = currentBreak === "xs" || currentBreak === "sm";
  const renderContent = () => {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, serviceGroups.services.map((service, index) => /* @__PURE__ */ React.createElement(ServiceRow, { service, key: "service-row-".concat(service.id, "-").concat(index) })), viewerSlots.slots.length > 0 && viewerSlots.slots.map((slot, index) => /* @__PURE__ */ React.createElement(ViewerSlotRow, { slot, key: "slot-row-".concat(slot.id, "-").concat(index) })));
  };
  if (isMobile) {
    return /* @__PURE__ */ React.createElement(React.Fragment, { key: "serviceGroups-mobile" }, /* @__PURE__ */ React.createElement(
      ScrollTable,
      {
        identifier: "serviceGroups",
        isFirstTable,
        headingLevel: initialHeadingLevel,
        title: serviceGroups.title,
        count: serviceGroups.count,
        packets
      },
      /* @__PURE__ */ React.createElement("tbody", null, renderContent())
    ), /* @__PURE__ */ React.createElement(ViewAllButton, { buttonProps: serviceGroups.viewAllButton }));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, { key: "serviceGroups-desktop" }, /* @__PURE__ */ React.createElement(SectionHeading, { isFirstTable, headingLevel: initialHeadingLevel, title: serviceGroups.title, count: serviceGroups.count }), /* @__PURE__ */ React.createElement(Table, { stickyHeader: "level-2" }, /* @__PURE__ */ React.createElement(PacketsTableHeader, { packets }), /* @__PURE__ */ React.createElement("tbody", null, renderContent())), /* @__PURE__ */ React.createElement(ViewAllButton, { buttonProps: serviceGroups.viewAllButton }));
};
export {
  ServiceGroups
};
